import React from 'react'
import propTypes from 'prop-types'
import GetAQuoteForm from '../../src/pages/GetAQuoteV2'
import topo from '../../src/assets/topo.png';
import styled from 'styled-components';
import { theme } from '../../src/themes/default-theme';
import { filterOverlayProps } from '../../src/data-restructure/ui/model-overlay';
import ReactHtmlParser from 'react-html-parser';
import {gql} from "apollo-boost";
import client from '../../src/graphql/client';
import {get, uniqBy, flatMap} from 'lodash';
import seoQuery from '../../src/graphql/queries/seo';
import contentBuilderQuery from '../../src/graphql/queries/content-builder';
import respImgQuery from '../../src/graphql/queries/resp-img';
import refactorBreadcrumbsData from '../../src/data-restructure/navigation/breadcrumbs/breadcrumbs';
import refactorBookAViewing from '../../src/data-restructure/pages/book-a-viewing';
import refactorOverlayProps from '../../src/data-restructure/ui/model-overlay'



const Container = styled.div`
    padding: 65px 0;
    position: relative;
    background-color: ${theme.palette.lightGrey};

    &:before {
        height: 60px;
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        background-position: center top;
        background-image: url(${topo});
        background-size: 400px auto;
        background-repeat: repeat-x;
    }
`

const GetAQuote = (props) => {
  console.log('get a quote page', props)
    return (
    	<Container>
        <GetAQuoteForm {...props} filterOverlayProps={filterOverlayProps} />
      </Container>
    )
}
    
GetAQuote.propTypes = {
}
    
GetAQuote.defaultProps = {
}

export async function getStaticProps() {
    const countryCode = process.env.DEV_COUNTRY_CODE ? process.env.DEV_COUNTRY_CODE : process.env.COUNTRY_CODE;
  
    const GET_CB_DATA = gql`
      query GET_CB_DATA {
        pageBy(uri: "get-a-quote?${countryCode.toLowerCase()}") {
          title
          seo {
            ${seoQuery}
          }
          ${contentBuilderQuery()}
          acf_domains {
            assignedDomains
          }
        }
        dealers(first: 1000) {
          nodes {
            title
            acf_dealers {
              addressLine1
              addressLine2
              phone
              sales
              country
              dealerID
              state
              latitude
              longitude
              postcode
              suburb
              postcodes
              motorhomes
              campervans
            }
          }
        }
        ranges(first: 10000) {
          nodes {
            title
            id
            rangeId
            acf_range {
              rangeSeriesRef {
                ... on Series {
                  id
                  title
                  acf_series {
                    seriesImage {
                      altText
                      mediaDetails {
                        sizes {
                          width
                          sourceUrl
                          name
                          height
                        }
                      }
                    }
                    seriesSpecsRep {
                      id
                      seriesSpecRepTitle
                    }
                  }
                }
              }
            }
          }
        }
        modelsFloorPlans(first: 10000) {
          nodes {
            id
            title
            acf_floor_plan {
              seriesSpec
              modelLayoutId
              modelLayoutName
              modelExternalImagesRep {
                modelExternalImagesRepImage {
                  ${respImgQuery}
                }
              }
              modelSeries {
                ... on Series {
                  id
                }
              }
            }
          }
        }
      }
    `
  
    const result = await client.query({
      query: GET_CB_DATA,
    });
  
    const context = get(result, 'data.pageBy', {});
    const dealers = get(result, 'data.dealers.nodes', []);
    
    const cbData = get(result, 'data.pageBy.acf_content_builder.contentBuilder', []);
    var title = '';
    var subTitle = '';
    for (var i=0; i<cbData.length; i++) {
        if (cbData[i].fieldGroupName == 'page_AcfContentBuilder_ContentBuilder_FcBodyText') {
            title = get(cbData[i], 'btHeading', null);
            subTitle = get(cbData[i], 'btBody', null);
        }
    }
  
    const country = countryCode === 'AU' ? "Australia" : "New Zealand";
  
    const assignedDomains = get(result, 'data.pageBy.acf_domains.assignedDomains', []); 
  
    const getDealersByCountry = (dealers) => {
      return dealers ? dealers.filter(dealer => {
        return (get(dealer, 'acf_dealers.country', '') === country) && get(dealer, 'acf_dealers.sales', '') === '1'
  
      }).map(dealer => {
        return {
          ...dealer,
          title: ReactHtmlParser(dealer.title)[0].toString() // title(format: RAW) is returning null so use this work around
        }
      }) : []
    }
  
    const props = refactorBookAViewing(result);

    const returnProps = {
        meta: {
          title: context ? context.title : null,
          seo: context ? context.seo : null,
          assignedDomains
        },
        breadcrumbs: await refactorBreadcrumbsData('/get-a-quote', assignedDomains),
        title,
        subTitle,
        dealers: getDealersByCountry(dealers),
        ranges: refactorOverlayProps(props.ranges),
        overlayProps: refactorOverlayProps(props.ranges),
        country,
        countryCode,
    }

    // console.log('returnProps >>>');
    // console.dir(returnProps,{depth:null});
  
    return {
      props: returnProps
    }
}
    
export default GetAQuote